"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const RulerIcon = React.forwardRef(function RulerIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M17.273 2.805l4.3 4.3a1 1 0 0 1 0 1.414L8.702 21.39a1 1 0 0 1-1.415 0l-4.3-4.3a1 1 0 0 1 0-1.414L15.86 2.805a1 1 0 0 1 1.414 0zm2.864 7.15L18.71 8.526m0 2.857l-1.43-1.428m0 2.857l-2.857-2.857m1.429 4.285l-1.429-1.428m0 2.857l-1.429-1.429m0 2.857l-2.857-2.857m1.429 4.286l-1.429-1.429m0 2.858L8.71 18.526" }) })));
});
export default RulerIcon;
//# sourceMappingURL=ruler.js.map